// extracted by mini-css-extract-plugin
export default {"lawyerPicture":"watchers_utils-module__lawyerPicture--lUiyP"};